const routes = {
  reservations: 'Orders',
};

export default routes;
